// extracted by mini-css-extract-plugin
module.exports = {"questionBox":"planetQuestion_questionBox__2UFDO","title":"planetQuestion_title__2EpkK"};